import { addMenuItemType, blockType } from '../../types/menus';

// outputs a map of menu type - blocks acc to the order of blocks passed to the function
export const getBlocksMapInOrder = (blocks: blockType[]) => {
  const blockTypeMenuItemMap = new Map<blockType['addMenuItemType'], blockType[]>();
  blocks.forEach((block) => {
    const blockTypeItems = blockTypeMenuItemMap.get(block.addMenuItemType);
    if (blockTypeItems) {
      blockTypeMenuItemMap.set(block.addMenuItemType, [...blockTypeItems, block]);
    } else {
      blockTypeMenuItemMap.set(block.addMenuItemType, [block]);
    }
  });
  return blockTypeMenuItemMap;
};

export const getBlocksDefaultMap = (blocks: blockType[]) => {
  let blockTypeMenuItemMap = new Map<blockType['addMenuItemType'], blockType[]>([
    [addMenuItemType.basic_blocks, [] as blockType[]],
    [addMenuItemType.media, [] as blockType[]],
    [addMenuItemType.embeds, [] as blockType[]],
    [addMenuItemType.assessments, [] as blockType[]],
    [addMenuItemType.contents, [] as blockType[]],
    [addMenuItemType.interactive_blocks, [] as blockType[]],
    [addMenuItemType.advanced_blocks, [] as blockType[]],
  ]);
  // Maintain the order. Items will be shown in same order.
  for (const block of blocks) {
    blockTypeMenuItemMap?.get(block.addMenuItemType)?.push(block);
  }
  return blockTypeMenuItemMap;
};

export const getBlocksFromMap = (blocksMap: Map<addMenuItemType, blockType[]>) => {
  const renderBlocks = [] as blockType[];
  blocksMap.forEach((value) => {
    if (value.length) {
      renderBlocks.push(...value);
    }
  });
  return renderBlocks;
};
